export default __webpack_public_path__ + "static/media/standard_05.e05821da.png";